// 导入服务
import { AuthService } from './auth';
import { UserService } from './user';
import { LoginRecordService } from './loginRecord';
import { TokenService } from './token';
import { TaskService } from './task';
import { DictService } from './dict';
import { OrgService } from './org';

// 导出基础服务
export { http, request, buildUrl } from './base';

// 导出所有 API 服务
export { default as AuthService } from './auth';
export { default as UserService } from './user';
export { default as LoginRecordService } from './loginRecord';
export { default as TokenService } from './token';
export { default as TaskService } from './task';
export { default as DictService } from './dict';
export { default as OrgService } from './org';

/**
 * API 服务类
 */
export class ApiService {
  // 认证相关
  static getCaptcha = AuthService.getCaptcha;
  static sendVerificationCode = AuthService.sendVerificationCode;
  static login = AuthService.login;
  static passwordLogin = AuthService.passwordLogin;
  static logout = AuthService.logout;
  static verifyToken = AuthService.verifyToken;
  
  // 用户管理相关
  static getUserList = UserService.getUserList;
  static getUserDetail = UserService.getUserDetail;
  static createUser = UserService.createUser;
  static updateUser = UserService.updateUser;
  
  // 登录记录相关
  static getLoginRecords = LoginRecordService.getLoginRecords;
  static kickout = LoginRecordService.kickout;
  
  // Token管理相关
  static getAllConfigs = TokenService.getAllConfigs;
  static createConfig = TokenService.createConfig;
  static updateConfig = TokenService.updateConfig;
  static getMyBalance = TokenService.getMyBalance;
  static getMyLogs = TokenService.getMyLogs;
  static consumeToken = TokenService.consumeToken;
  static getUserToken = TokenService.getUserToken;
  static getUserTokenLogs = TokenService.getUserTokenLogs;
  static performOperationForUser = TokenService.performOperationForUser;
  
  // 任务管理相关
  static getTaskTypeList = TaskService.getTaskTypeList;
  
  // 字典管理相关
  static getDictList = DictService.getDictList;
  static createDict = DictService.createDict;
  static getDictDetail = DictService.getDictDetail;
  static updateDict = DictService.updateDict;
  static deleteDict = DictService.deleteDict;
  static getDictByType = DictService.getDictByType;
  static getDictValue = DictService.getDictValue;
  static setDictValue = DictService.setDictValue;
  
  // 组织管理相关
  static createOrg = OrgService.createOrg;
  static getOrgList = OrgService.getOrgList;
  static getOrgDetail = OrgService.getOrgDetail;
  static updateOrg = OrgService.updateOrg;
  static deleteOrg = OrgService.deleteOrg;
  static restoreOrg = OrgService.restoreOrg;
}

export default ApiService;
